import { useState, useEffect } from 'react';
import api from '../services/api';
import useCurrentUser from './useCurrentUser';

export default function usePreferences() {
    const currentUser = useCurrentUser();
    const [preferences, setPreferences] = useState({
        accentColor: '#4f46e5',
        darkMode: false,
        livreurColors: {},
    });
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const loadPreferences = async () => {
            try {
                const res = await api.get('/users');
                const users = res.data.member || [];
                const me = users.find(u => u.email === currentUser?.email);
                if (me) {
                    setUserId(me.id);
                    if (me.preferences) {
                        setPreferences(prev => ({ ...prev, ...me.preferences }));
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };
        if (currentUser) loadPreferences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.email]);

    const savePreferences = async (newPrefs) => {
        const updated = { ...preferences, ...newPrefs };
        setPreferences(updated);
        if (userId) {
            try {
                await api.patch(`/users/${userId}`, { preferences: updated }, {
                    headers: { 'Content-Type': 'application/merge-patch+json' }
                });
            } catch (err) {
                console.error(err);
            }
        }
    };

    return { preferences, savePreferences };
}